









import { Component } from 'vue-property-decorator';
import { BaseCustomComponent } from './base-custom-component';

@Component
export default class InputComponent extends BaseCustomComponent {}
